const CardFramework = ({ framework, onClick }) => {
  return (
    <div
      className="bg-white p-4 rounded-xl shadow hover:bg-gray-50 cursor-pointer transition flex gap-3"
      onClick={onClick}
    >
      {framework.image_url && (
        <img
          src={framework.image_url}
          alt=""
          className="w-16 h-16 object-cover rounded-lg border border-gray-200 flex-shrink-0"
        />
      )}
      <div className="min-w-0 flex-1">
        <h3 className="text-md font-semibold truncate">{framework.name}</h3>
        {framework.description && (
          <p className="text-sm text-gray-600 mt-0.5 line-clamp-2">{framework.description}</p>
        )}
      </div>
    </div>
  );
};

export default CardFramework;
